// ハンバーガーメニュー
document.addEventListener("DOMContentLoaded", () => {
  //定義
  const drawerIcon = document.querySelector(".c_menu__icon");
  const drawer = document.querySelector(".c_menu__container");
  const drawerNavItem = document.querySelectorAll('.c_menu__inner a[href^="#"]');
  const headerHeight = document.querySelector("header").offsetHeight;
  const breakpoint = 768;
  let isMenuOpen = false;
  let isMenuOpenAtBreakpoint = false;

  //メニューを開くアニメーション
  const openMenu = () => {
    if (!drawer.classList.contains("is-active")) {
      drawer.classList.add("is-active");
      drawerIcon.classList.add("is-active");
    }
  };
  //メニューを閉じるアニメーション
  const closeMenu = () => {
    if (drawer.classList.contains("is-active")) {
      drawer.classList.remove("is-active");
      drawerIcon.classList.remove("is-active");
      isMenuOpen = false;
    }
  };
  //メニューの開閉動作
  const toggleMenu = () => {
    if (!drawer.classList.contains("is-active")) {
      openMenu();
    } else {
      closeMenu();
    }
  };
  //リサイズ処理
  const handleResize = () => {
    const bp = breakpoint;
    const windowWidth = window.innerWidth;
    if (windowWidth > bp && isMenuOpenAtBreakpoint) {
      closeMenu();
    } else if (windowWidth <= bp && drawer.classList.contains("is-active")) {
      isMenuOpenAtBreakpoint = true;
    }
  };
  //メニュー外クリック処理
  const clickOuter = (event) => {
    if (drawer.classList.contains("is-active") && !drawer.contains(event.target) && isMenuOpen) {
      closeMenu();
    } else if (drawer.classList.contains("is-active") && !drawer.contains(event.target)) {
      isMenuOpen = true;
    }
  };
  //該当箇所までスクロール
  const linkScroll = (target) => {
    if (target) {
      const targetPosition = target.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = targetPosition;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  //アイコン クリック時
  drawerIcon.addEventListener("click", toggleMenu);
  //画面幅リサイズ時
  window.addEventListener("resize", handleResize);
  //メニュー外クリック時
  document.addEventListener("click", clickOuter);
  //ページ内リンクメニュー クリック時
  drawerNavItem.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();
      closeMenu();
      const targetItem = document.querySelector(item.getAttribute("href"));
      linkScroll(targetItem);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('a[href^="#"]');
  links.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();
      const targetId = item.getAttribute("href");
      const target = document.querySelector(targetId);
      if (target) {
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });
});

window.addEventListener("load", function () {
  // 対象の要素を取得
  const clipViewItems = document.querySelectorAll(".c_animated__clipView");
  const clipViewItemsReverse = document.querySelectorAll(".c_animated__clipView--reverse");

  // スクロールイベントを監視
  window.addEventListener("scroll", function () {
    const windowHeight = window.innerHeight; // 画面の高さを取得

    // 共通の処理関数
    function handleScroll(items) {
      items.forEach((item) => {
        const rect = item.getBoundingClientRect(); // 要素の位置を取得

        if (rect.top < windowHeight * 0.8) {
          // 要素が画面の80%以内に入ったらクラスを追加
          item.classList.add("js-show");
        }
      });
    }

    // 各要素に処理を適用
    handleScroll(clipViewItems);
    handleScroll(clipViewItemsReverse);
  });
});

window.addEventListener("load", function () {
  // 監視対象の要素を取得
  const underTextItems = document.querySelectorAll(".c_animated__underText");
  // スクロールイベントを追加
  window.addEventListener("scroll", function () {
    const windowHeight = window.innerHeight;

    underTextItems.forEach((item) => {
      const rect = item.getBoundingClientRect(); // 要素の位置を取得
      const elementTop = rect.top; // 要素の上端の位置

      if (elementTop < windowHeight * 0.7) {
        // 画面の70%位置を超えたらクラスを追加
        item.classList.add("js-show");
      }
    });
  });
});




// タイトルを分割する関数
function splitText(element) {
  const text = element.textContent;
  element.textContent = ""; // 元のテキストをクリア
  text.split("").forEach((char) => {
    const span = document.createElement("span");
    span.textContent = char;
    element.appendChild(span);
  });
}

// 各見出しのアニメーションを設定する関数
function animateTitles() {
  const titleWraps = document.querySelectorAll(".c_title-wrap");
  titleWraps.forEach((titleWrap) => {
    const enTitle = titleWrap.querySelector(".c_title--en");
    const jaTitle = titleWrap.querySelector(".c_title--ja");
    const rect = titleWrap.getBoundingClientRect();

    // ビューポート内に入るとアニメーションを開始
    if (rect.top <= window.innerHeight * 0.9 && !titleWrap.classList.contains("animated")) {
      const enSpans = enTitle.querySelectorAll("span");
      const jaSpans = jaTitle.querySelectorAll("span");

      // News のアニメーション
      enSpans.forEach((span, index) => {
        setTimeout(() => span.classList.add("animate"), index * 70); // 1文字ずつアニメーション
      });

      // 0.5秒後に お知らせ のアニメーション
      setTimeout(() => {
        jaSpans.forEach((span, index) => {
          setTimeout(() => span.classList.add("animate"), index * 70); // 1文字ずつアニメーション
        });
      }, 500);

      // アニメーション済みのフラグを設定
      titleWrap.classList.add("animated");
    }
  });
}

// 初期化: テキストを分割
document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll(".c_title--en, .c_title--ja");
  titles.forEach(splitText);

  // 初期状態でもアニメーションをチェック
  animateTitles();

  // スクロールイベントでアニメーションをトリガー
  window.addEventListener("scroll", animateTitles);
});



document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.c_fadeIn');

  const fadeInOnScroll = () => {
    const triggerPosition = window.innerHeight * 0.7; // 画面上部70%の位置

    faqItems.forEach(item => {
      const itemPosition = item.getBoundingClientRect().top;

      if (itemPosition <= triggerPosition) {
        item.classList.add('is-visible'); // フェードインさせるクラスを追加
      }
    });
  };

  window.addEventListener('scroll', fadeInOnScroll);
  fadeInOnScroll(); // ページ読み込み時にも実行
});
